import { getEquityByLevels, getEquitySummaryCards } from "@/api/financialReport";
import { createBalanceLevelReport } from "./createBalanceLevelReport";

// Tab Patrimonio: saldo acumulado del nivel-1 "Patrimonio". Misma lógica que
// Activos/Pasivos (factory compartido), sólo cambia el endpoint y las etiquetas.
export default createBalanceLevelReport({
    fetchBreakdown: getEquityByLevels,
    fetchSummary: getEquitySummaryCards,
    totalLabel: "Patrimonio",
    ratioLabel: "Patrimonio / Ventas (%)",
    errorLabel: "Error al cargar patrimonio.",
    summaryErrorLabel: "Error al cargar resumen de patrimonio.",
    logPrefix: "[equityReport]",
});
